module.exports = __webpack_public_path__ + "static/media/roadmap.489a7764.svg";